<template>
  <div class="rep-profile">
    <!-- Basic Info Section -->
    <div class="d-flex flex-column mb-2">
      <h2 v-if="!hideExtra" class="text-center mb-1">{{ repInfo?.Name }}</h2>
      <div v-if="!hideExtra"
           class="badge text-white align-self-center"
        :style="{ background: getRepColor(repInfo) }"
      >
        <strong>{{ repBadgeLabel(repInfo) }}</strong>
      </div>
    </div>

    <!-- Details Grid -->
    <div class="datagrid mb-4" v-if="!hideExtra" >
      <div class="datagrid-item mt-2" v-if="repInfo?.['Phone Number']">
        <div class="datagrid-title">{{ __DICT__.phone }}</div>
        <div class="datagrid-content">
          <a
            :href="useActionSheet ? '#' : `tel:${repInfo['Phone Number']}`"
            class="text-primary"
            @click.prevent="handlePhoneClick"
          >
            <IconPhone class="icon me-1" :size="24" />
            {{ repInfo['Phone Number'] }}
          </a>
        </div>
      </div>
    </div>

    <RepDetails :rep-info="repInfo" :loading="false" />
    <RepTravel :rep-info="repInfo" />
  </div>
</template>

<script setup>
import RepTravel from '@/components/RepTravel.vue'
import RepDetails from '@/components/RepDetails.vue'
import { IconPhone } from '@tabler/icons-vue'
import { getRepColor } from '@/utils/accommodationUtils.js'
import { repBadgeLabel } from '@/constants/staff.js'


const props = defineProps({
  repInfo: { type: Object, required: true },
  hideExtra: { type: Boolean, default: false },
  // If true, clicking phone emits an event (for Action Sheet in parent). Otherwise, use tel: link.
  useActionSheet: { type: Boolean, default: false }
})

const emit = defineEmits(['phone-click'])

const handlePhoneClick = (e) => {
  if (!props.useActionSheet) return // let native tel: work
  // use action sheet behavior
  emit('phone-click', props.repInfo?.['Phone Number'] || '')
}
</script>
